import {DealListSort} from "@irati/types"

export const SORT_OPTIONS = [
  {value: DealListSort.Date, label: "perks.constants.sortOptions.date"},
  {value: DealListSort.Popularity, label: "perks.constants.sortOptions.popularity"},
  {value: DealListSort.FromPriceAsc, label: "perks.constants.sortOptions.price.asc"},
  {value: DealListSort.FromPriceDesc, label: "perks.constants.sortOptions.price.desc"}
]
